// extracted by mini-css-extract-plugin
export default {"container":"style_container__DTVIE","card":"style_card__6h9zZ","styleH2":"style_styleH2__mJLKu","wapper":"style_wapper__kvEY8"};